<template>
  <v-widget
    :title="$t('Password Settings')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        :loading="passwordGenerateInProgress"
        small
        @click="generatePassword()"
      >
        {{ $t('Generate password') }}
      </v-btn>
      <v-btn
        :loading="passwordResetInProgress"
        small
        color="primary"
        @click="resetPassword()"
      >
        {{ $t('Reset password') }}
      </v-btn>
    </div>
    <div slot="widget-content">
      <v-form
        dense
      >
        <v-checkbox
          v-if="!passwordChangeRequested"
          v-model="user.require_password_change"
          :error-count="user.displayErrors('require_password_change').length"
          :error-messages="user.displayErrors('require_password_change')"
          :label="$t('Require password change on first login')"
        />

        <div
          v-else
          class="password-change-notice"
        >
          {{ $t('Customer has been requested to change password on first login attempt.') }}
        </div>

        <v-text-field
          v-model="user.password"
          :error-count="user.displayErrors('password').length"
          :error-messages="user.displayErrors('password')"
          :label="$t('New password')"
          outline
          type="password"
        />

        <v-text-field
          v-model="user.password_confirmation"
          :error-count="user.displayErrors('password_confirmation').length"
          :error-messages="user.displayErrors('password_confirmation')"
          :label="$t('New password confirmation')"
          outline
          type="password"
        />
        <v-btn
          :loading="passwordSaveInProgress"
          color="primary"
          @click="savePassword()"
        >
          {{ $t('Save new password') }}
        </v-btn>

      </v-form>
    </div>
  </v-widget>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CustomerPassword',

  props: {
    customer: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      menu: false,
      passwordResetInProgress: false,
      passwordGenerateInProgress: false,
      passwordSaveInProgress: false,
      passwordChangeRequested: false,
      user: this.$http.make('auth:user')
    }
  },

  computed: {
    ...mapGetters(['tenancy'])
  },

  async mounted () {
    this.user = await this.user.getByCustomerId(this.customer.id)
    this.passwordChangeRequested = this.user.require_password_change
  },

  methods: {
    async resetPassword () {
      try {
        const url = this.tenancy.url.replace(/\/$/, '') + '/auth/password/change'

        const data = {
          email: this.customer.email,
          redirect_url: url
        }

        this.passwordResetInProgress = true
        await this.user.resetPassword(data)
        this.passwordResetInProgress = false

        this.$toast.success(this.$t('Password reset link sent to customer.'))
      } catch (error) {
        this.passwordResetInProgress = false
      }
    },

    async generatePassword () {
      try {
        this.passwordGenerateInProgress = true
        await this.user.generateNewPassword()
        this.passwordGenerateInProgress = false

        this.$toast.success(this.$t('New password has been generated.'))
      } catch (error) {
        this.passwordGenerateInProgress = false
      }
    },

    async savePassword () {
      try {
        this.passwordSaveInProgress = true
        await this.user.save()
        this.passwordSaveInProgress = false
        this.clearPasswordFields()
        this.passwordChangeRequested = this.user.require_password_change

        this.$toast.success(this.$t('New password has been saved.'))
      } catch (error) {
        this.passwordSaveInProgress = false
      }
    },

    clearPasswordFields () {
      this.user.password = ''
      this.user.password_confirmation = ''
    }
  }
}
</script>

<style lang="stylus">
  .password-change-notice {
    color: red;
    display: block;
    padding: 20px 0;
    text-align: center;
  }
</style>
